import { render, staticRenderFns } from "./WebsiteHeaderFullWidth.vue?vue&type=template&id=0d5a6518"
import script from "./WebsiteHeaderFullWidth.vue?vue&type=script&lang=ts"
export * from "./WebsiteHeaderFullWidth.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../nuxt-app/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports